import Vue from "vue";
import Router from "vue-router";
import LongForm from "./views/LongForm.vue";
import Focus from "./components/Focus.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/IT"
    },
    {
      path: "/:lang",
      name: "home",
      component: LongForm
    },
    {
      path: "/focus/:focusId/:lang",
      name: "home",
      component: Focus
    }
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: {
          x: 0,
          y: 0
        }
      };
    }
  }
});
